type RuntimeConfig = {
  VITE_API_URL?: string;
  VITE_BASE_URL?: string;
  VITE_KITCHEN_URL?: string;
  VITE_PRINTER_AGENT_ANDROID_URL?: string;
};

// config.js est chargé avant tout module dans index.html, donc cet objet est
// déjà rempli quand ce fichier s'exécute. Fallback sur les valeurs Vite pour
// `vite dev` hors conteneur.
const runtime: RuntimeConfig =
  (window as Window & { __RUNTIME_CONFIG__?: RuntimeConfig })
    .__RUNTIME_CONFIG__ ?? {};

export const VITE_API_URL: string =
  runtime.VITE_API_URL || import.meta.env.VITE_API_URL || '';

export const VITE_BASE_URL: string =
  runtime.VITE_BASE_URL || import.meta.env.VITE_BASE_URL || '';

// Pas de variable d'env dédiée pour l'instant (voir docker-compose.yml,
// service kitchen-dev, KITCHEN_DEV_PORT:-5175) — IP LAN en dur pour que la
// webview s'affiche aussi depuis une tablette, pas seulement ce poste.
export const VITE_KITCHEN_URL: string =
  runtime.VITE_KITCHEN_URL ||
  import.meta.env.VITE_KITCHEN_URL ||
  'http://10.2.2.172:5175/';

// Build Expo de l'agent d'impression Android — pas encore de release store,
// donc lien direct vers le build de test tant qu'il n'y a qu'une seule
// plateforme mobile supportée.
export const VITE_PRINTER_AGENT_ANDROID_URL: string =
  runtime.VITE_PRINTER_AGENT_ANDROID_URL ||
  import.meta.env.VITE_PRINTER_AGENT_ANDROID_URL ||
  'https://expo.dev/accounts/malodev/projects/m-print-agent/builds/57f4a5c7-758c-4a6b-8609-0b0a8af5a771';
